import { splitProps } from "solid-js";
import type { JSX, ParentProps } from "solid-js";

interface Props extends JSX.HTMLAttributes<HTMLDivElement> {
    variant?: "default" | "raised" | "interactive";
}

export function Card(props: ParentProps<Props>) {
    const [own, rest] = splitProps(props, ["variant", "class", "children"]);
    const cls = () => ["ui-card", `ui-card-${own.variant ?? "default"}`, own.class ?? ""].filter(Boolean).join(" ");
    return (
        <div {...rest} class={cls()}>
            {own.children}
        </div>
    );
}
